module.exports = __webpack_public_path__ + "img/9788925534145.be3c32fa.jpg";